var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_sms",
    "data-name": "vuesax/linear/sms",
    transform: "translate(-556 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms",
    transform: "translate(556 250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.875,13.458H3.958C1.583,13.458,0,12.271,0,9.5V3.958C0,1.188,1.583,0,3.958,0h7.917c2.375,0,3.958,1.188,3.958,3.958V9.5C15.833,12.271,14.25,13.458,11.875,13.458Z",
    transform: "translate(1.583 2.771)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.917,0,5.439,1.979a2.506,2.506,0,0,1-2.969,0L0,0",
    transform: "translate(5.542 7.125)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H19V19H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.35a514c7d392f3aa445143e23a382a31.svg";
export { ForwardRef as ReactComponent };